import React, { useEffect } from 'react';
import checkboxImg from '@/assets/image/checkbox.svg';
import checkboxSelectImg from '@/assets/image/checkbox-select.svg';
import { storagePrefixV2 } from '@/constant';
import { ShowTitle } from '../show-title';
import {
  setCurrentStep,
  setFormValue,
  setNextBtnConfig,
  setPrevBtnConfig,
  useAIDiagnoseStore,
} from '../../store/useAIDiagnoseStore';

import cx from './index.module.scss';

interface Props {}

export const PHYSICAL_CONDITION_ITEMS: Record<
  AIDiagnose.PhysicalConditionItems,
  {
    name: string;
    imgUrl: string;
  }
> = {
  stomachAndGut: {
    name: '肠胃不适',
    imgUrl: storagePrefixV2 + '/ai-consulation/bodyadjust-tips/adqwfqwf.png',
  },
  menstrual: {
    name: '月经不调',
    imgUrl: storagePrefixV2 + '/ai-consulation/bodyadjust-tips/asdqwfgq.png',
  },
  fatigue: {
    name: '疲乏',
    imgUrl: storagePrefixV2 + '/ai-consulation/bodyadjust-tips/wqdqwfkoir.png',
  },
  dizziness: {
    name: '头晕',
    imgUrl: storagePrefixV2 + '/ai-consulation/bodyadjust-tips/ascaszx.png',
  },
  hairFall: {
    name: '掉发',
    imgUrl: storagePrefixV2 + '/ai-consulation/bodyadjust-tips/wdloxasd.png',
  },
  sleepiness: {
    name: '失眠',
    imgUrl: storagePrefixV2 + '/ai-consulation/bodyadjust-tips/sadlxzcasd.png',
  },
};

export const PhysicalCondition: React.FC<Props> = () => {
  const { userInfo, physicalCondition } = useAIDiagnoseStore.use.formValue();

  useEffect(() => {
    setPrevBtnConfig({
      show: true,
      action: () => {
        setCurrentStep(prev => ({ currentStep: prev - 1 }));
      },
    });

    setNextBtnConfig({
      disable: !physicalCondition?.length,
      action: () => {
        setCurrentStep(prev => ({ currentStep: prev + 1 }));
      },
    });
  }, [physicalCondition?.length]);

  return (
    <div className={cx('PhysicalCondition')}>
      <ShowTitle title="您希望改善的体质问题" subTitle="可选多个问题" />
      <div className={cx('content')}>
        <div className={cx('condition-wrapper')}>
          {Object.keys(PHYSICAL_CONDITION_ITEMS)
            ?.filter(item => {
              if (userInfo?.gender === 'Male') {
                // 男性过滤该选项
                return item !== 'menstrual';
              } else {
                return true;
              }
            })
            .map(item => (
              <div
                className={cx('condition-item', {
                  selected: physicalCondition?.includes(item as AIDiagnose.PhysicalConditionItems),
                })}
                key={item}
                onClick={() =>
                  setFormValue({
                    physicalCondition: physicalCondition?.includes(item as AIDiagnose.PhysicalConditionItems)
                      ? physicalCondition?.filter(item2 => item2 !== item)
                      : [...(physicalCondition || []), item as AIDiagnose.PhysicalConditionItems],
                  })
                }
                style={{
                  backgroundImage: `url(${
                    PHYSICAL_CONDITION_ITEMS[item as AIDiagnose.PhysicalConditionItems]?.imgUrl
                  })`,
                }}
              >
                <div className={cx('name')}>{PHYSICAL_CONDITION_ITEMS[item]?.name}</div>
                <img
                  src={
                    physicalCondition?.includes(item as AIDiagnose.PhysicalConditionItems)
                      ? checkboxSelectImg
                      : checkboxImg
                  }
                  alt=""
                  className={cx('checkbox')}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
